import { formatDriverDisplayName } from '@multirx/shared/game/driverDisplayLabel.js';
import { getCurrentUser } from './session.js';

/** Id du pilote lié au compte connecté, ou null. */
export function getOwnDriverId(): number | null {
  return getCurrentUser()?.driverId ?? null;
}

/** Ajoute « (vous) » si `driverId` est celui du compte connecté. */
export function labelOwnDriver(name: string, driverId: number | null | undefined): string {
  return formatDriverDisplayName(name, driverId, getOwnDriverId());
}
